import { XBuildifyGlobalSettings } from '@adornis/buildify/client/components/x-buildify-global-settings.js';
import { customElement } from 'lit/decorators.js';

@customElement('d-buildify-global-settings')
export class DBuildifyGlobalSettings extends XBuildifyGlobalSettings {}
